/**
 * ORBCOMM adapter stub — IOT-DEPLOY-DARK-1 Day 2.
 *
 * ORBCOMM is a TYPE-ONLY integration: device profiles and capability matrices
 * are declared; live API calls throw VendorNotIntegratedError.
 * Full integration scheduled post-pilot.
 *
 * Supported models: ST 6100, ST 9100 (asset tracking + temperature monitoring).
 * Capability surface: GPS, temperature, door, shock, battery, cell signal.
 * Config push: cloud-only via ORBCOMM OTA API. OTA supported in hardware;
 *   API integration not yet implemented.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const ORBCOMM_CAPABILITIES = {
  configKeys: {
    reporting_interval_sec: {
      pushable: true,
      readable: true,
      range: [60, 86400],
      requiresActivation: false,
      unit: 'seconds',
      description: 'Position/telemetry reporting interval',
    },
    geofence_enabled: {
      pushable: true,
      readable: true,
      enum: ['true', 'false'],
      requiresActivation: false,
      description: 'Enable onboard geofence alerting',
    },
  },
  telemetryTypes: [
    'gps_position', 'temperature_c', 'door_open_bool', 'shock_g',
    'battery_voltage_v', 'cell_signal_dbm',
  ],
  alertingMode: 'hybrid',
  otaSupported: true,
  attestationSupported: false,
  rollbackSupported: false,
  pushLatencyExpectedMs: 30_000,
};

export class ORBCOMMAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'orbcomm', ORBCOMM_CAPABILITIES);
  }
}

/**
 * Factory for HalService.registerAdapter('orbcomm', createORBCOMMAdapterFactory()).
 */
export function createORBCOMMAdapterFactory() {
  return (device) => new ORBCOMMAdapter(device);
}
